import mila from 'markdown-it-link-attributes';
import mentionPlugin from './markdownIt/link';
import MarkdownIt from 'markdown-it';

// [UPSTREAM-ADAPT 1beaa284c6] width (arrastar o canto, imageResizeView) ganha do height
// (assinatura antiga, seletor Small/Medium/Large/Original ja removido)
const setImageSizing = inlineToken => {
  const imgSrc = inlineToken.attrGet('src');
  if (!imgSrc) return;
  const url = new URL(imgSrc);
  const width = url.searchParams.get('cw_image_width');
  if (width) {
    inlineToken.attrSet(
      'style',
      `width: ${width}; max-width: 100%; height: auto;`
    );
    return;
  }
  const height = url.searchParams.get('cw_image_height');
  if (height) inlineToken.attrSet('style', `height: ${height};`);
};

const processInlineToken = blockToken => {
  blockToken.children.forEach(inlineToken => {
    if (inlineToken.type === 'image') {
      setImageSizing(inlineToken);
    }
  });
};

const imgResizeManager = md => {
  // Se a URL da imagem carrega cw_image_width ou cw_image_height, acrescenta um atributo de
  // estilo inline para o <img> renderizado respeitar o tamanho escolhido pelo agente.
  md.core.ruler.after('inline', 'add-image-sizing', state => {
    state.tokens.forEach(blockToken => {
      if (blockToken.type === 'inline') {
        processInlineToken(blockToken);
      }
    });
  });
};

const createMarkdownInstance = (linkify = true) => {
  return (
    MarkdownIt({
      html: false,
      xhtmlOut: true,
      breaks: true,
      langPrefix: 'language-',
      linkify,
      typographer: true,
      quotes: '\u201c\u201d\u2018\u2019',
      maxNesting: 20,
    })
      // [UPSTREAM-ADAPT c1d167bd64] desliga setext heading (sublinhado por "--"
      // ou "==="): sem isso, o delimitador de assinatura "--" apos um paragrafo
      // era lido como titulo H2 e a bolha renderizava uma barra invertida solta.
      .disable(['lheading'])
      .use(mentionPlugin)
      .use(imgResizeManager)
      .use(mila, {
        attrs: {
          class: 'link',
          rel: 'noreferrer noopener nofollow',
          target: '_blank',
        },
      })
  );
};

// [UPSTREAM 59d869d1ed #14611] A tabela de artigo da central de ajuda persiste a largura de
// coluna redimensionada como comentario `<!--cw-colwidths:...-->` antes da tabela, so pra ida e
// volta do markdown no editor; nunca deve aparecer como texto. O markdown-it roda com
// `html: false`, que escaparia isso pra um comentario visivel na saida renderizada/plana
// (ex.: trecho de busca no dashboard). Remove na entrada.
const COLWIDTHS_MARKER_REGEX = /<!--cw-colwidths:[\d,]+-->\r?\n?/g;

const TWITTER_USERNAME_REGEX = /(^|[^@\w])@(\w{1,15})\b/g;
const TWITTER_USERNAME_REPLACEMENT = '$1[@$2](http://twitter.com/$2)';
const TWITTER_HASH_REGEX = /(^|\s)#(\w+)/g;
const TWITTER_HASH_REPLACEMENT = '$1[#$2](https://twitter.com/hashtag/$2)';

class MessageFormatter {
  constructor(
    message,
    isATweet = false,
    isAPrivateNote = false,
    linkify = true
  ) {
    this.message = (message || '').replace(COLWIDTHS_MARKER_REGEX, '');
    this.isAPrivateNote = isAPrivateNote;
    this.isATweet = isATweet;
    this.linkify = linkify;
    this.md = createMarkdownInstance(linkify);
  }

  formatMessage() {
    let updatedMessage = this.message;
    if (this.isATweet && !this.isAPrivateNote) {
      updatedMessage = updatedMessage.replace(
        TWITTER_USERNAME_REGEX,
        TWITTER_USERNAME_REPLACEMENT
      );
      updatedMessage = updatedMessage.replace(
        TWITTER_HASH_REGEX,
        TWITTER_HASH_REPLACEMENT
      );
    }
    return this.md.render(updatedMessage);
  }

  // [UPSTREAM-ADAPT 08260f3be7] Renderiza o markdown SEM imagens. Usado na pré-visualização do
  // conteúdo capturado pelo crawler, onde as imagens do site de origem só poluiriam a leitura (e
  // seriam requisições externas disparadas de dentro do painel).
  //
  // [UPSTREAM-ADAPT 1beaa284c6] a regra passou a se chamar `add-image-sizing` (era
  // `add-image-height`, ver `imgResizeManager` acima), entao o nome aqui teve que acompanhar; o
  // [UPSTREAM-SKIP 08260f3be7] anterior nao vale mais.
  disableImageRendering() {
    this.md.disable(['add-image-sizing']);
    this.md.renderer.rules.image = () => '';
  }

  get formattedMessage() {
    return this.formatMessage();
  }

  get plainText() {
    const strippedOutHtml = new DOMParser().parseFromString(
      this.formattedMessage,
      'text/html'
    );
    return strippedOutHtml.body.textContent || '';
  }
}

export default MessageFormatter;
